import api from '../../utils/api'
import { useState, useEffect } from "react"
import { FiInbox } from 'react-icons/fi'
import { MdAddPhotoAlternate } from 'react-icons/md'

/* form */
import NewClientImg from "./NewClientImg"
import Button from "../../shared/components/Button/Button"

//list
import ListClientImgRow from "./ListRow/ListClientImgRow"
//Modal
import Modal from '../../shared/modal/Modal'



function ListClientImg({ clientId, pageMode, handleOnAddImg, selectedArray }) {
    const [clientImgs, setClientImgs] = useState([])
    const [token] = useState(localStorage.getItem('token') || '')
    const [load, setLoad] = useState(false)

    //------------------ MODAL ------------------------
    //------------- NEW ---------------
    const [modalNewClientImg, setModalNewClientImg] = useState(false)
    const newClientImg = (status) => {
        if (status === 'success') {
            setModalNewClientImg(false)
        }
    }

    //-------------------------------------------------

    // ---------------CLIENT IMG SELECTED ----------------
    const [clientImgSelectedArray, setClientImgSelectedArray] = useState(selectedArray || [])
    const handleOnSelect = (selected) => {
        if (selected._id) {
            let itemExist = false
            clientImgSelectedArray.map((item) => {
                if (item._id === selected._id) {
                    itemExist = true
                }
            })
            if (!itemExist) {
                setClientImgSelectedArray([...clientImgSelectedArray, selected])
            } else {
                setClientImgSelectedArray(clientImgSelectedArray.filter((item) => item._id !== selected._id))

            }

        }
    }

    //---------------------------------------------------
    useEffect(() => {

        getAll()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [token])

    const getAll = () => {
        api.get(`clientImg/getallimgbyclient/${clientId}`, {
            headers: {
                Authorization: `Bearer ${JSON.parse(token)}`
            }
        }).then((response) => {

            if (response.data) {
                setClientImgs(response.data.clientImgs)
                setLoad(true)
            }
        })
    }
    //----------------------handle on add new image ---------------
    const listUpdate = () => {
        getAll()
    }

    if (!load) {
        return <div className="pg-loading">Carregando imagens...</div>
    }

    return (
        <section className="pg-page">

            <div className="pg-sticky-top">
                <div className="pg-header">
                    <div className="pg-header-title">
                        <p className="pg-title">Imagens de Referência</p>
                        <span className="pg-title-accent" />
                    </div>
                    <div className="pg-header-row">
                        <div className="pg-header-actions">
                            {pageMode === 'modal' && (
                                <Button variant="finish" onClick={() => handleOnAddImg(clientImgSelectedArray)}>Concluir</Button>
                            )}
                            <Button variant="new" icon={MdAddPhotoAlternate} onClick={() => setModalNewClientImg(true)}>Nova Imagem</Button>
                        </div>
                        <div className="pg-header-right">
                            <span className="pg-count">
                                {clientImgSelectedArray.length} {clientImgSelectedArray.length === 1 ? 'selecionada' : 'selecionadas'}
                            </span>
                        </div>
                    </div>
                </div>
            </div>

            <div className="pg-list">
                {clientImgs.length > 0 ? (
                    <ListClientImgRow dataArray={clientImgs} handleOnSelect={handleOnSelect} selectedArray={clientImgSelectedArray} />
                ) : (
                    <div className="pg-empty">
                        <FiInbox size={32} className="pg-empty-icon" />
                        <p className="pg-empty-title">Nenhuma imagem cadastrada</p>
                        <p className="pg-empty-subtitle">Cadastre a primeira imagem de referência deste cliente.</p>
                    </div>
                )}
            </div>

            <Modal
                modalStatus={modalNewClientImg}
                changeStatus={setModalNewClientImg}
                w={60}
                content={
                    <NewClientImg clientId={clientId} handleSubmit={newClientImg} handleOnSuccess={listUpdate} btCancelAction={() => setModalNewClientImg(false)} />
                }
            />

        </section>
    )
}

export default ListClientImg
